<div class="results" data-element="results-list">

  <div class="run-status pending" *ngIf="this.isPending">
    <dx-load-indicator [height]="18" [width]="18"></dx-load-indicator>
    <span class="msg">Running ORION…</span>
  </div>

  <!-- Explicit "no suggestions" — a VALID outcome, not an error. -->
  <div class="empty-state" *ngIf="this.isEmpty" data-element="results-empty-state">
    No Suggestions For These Inputs.
  </div>

  <div class="failed-state" *ngIf="this.isFailed">
    The ORION Run Could Not Complete. Please Try Again.
  </div>

  <!-- The backend's notes about THIS RUN'S BASIS - today, only "no current zone, so both #2B and
       #3 were priced". Shown verbatim, above the cards and beside the empty state.

       ⚠ WHAT WAS HERE: the four-line COVERAGE NOTE (calendar coverage / not priced in time /
       filtered out by your settings / no days left to run). Removed by ruling R-C, 2026-09-10 -
       nothing about a dropped, excluded, filtered or unpriced day reaches the trader; the backend
       logs it instead. A warning is a different thing and stays: it describes the basis of every
       card shown, not a day that is missing. -->
  <div class="coverage-note" *ngIf="this.hasWarningNotes" data-element="results-coverage-note">
    <p *ngFor="let w of this.warningNotes" data-element="coverage-backend-warning">{{ w }}</p>
  </div>

  <ng-container *ngIf="this.hasCards">

    <!-- THE RESULTS TOOLBAR (owner ruling O47/O50, 2026-09-07). His words: "a little label to sort
         the results by price, similar to the concept we have in the Hedge Matrix ORION… by default
         sorted from the best price to the worst, but if prices change, the user can manually
         re-click that sorting label".

         So this is the Hedge Matrix control, brought over deliberately rather than re-invented —
         same three states per key, same arrow glyphs, same right-aligned "reads as a tool, not a
         heading" placement.

         TYPE SITS BEFORE PRICE (owner ruling O59). It is the outer key: it is how he chooses which
         adjustment types lead, and lane blocks were explicitly ruled out in its favour — "lane is an
         ephemeral concept, an aggregation".

         ⚠ The <i> is rendered UNCONDITIONALLY and carries its glyph through [ngClass] — a null class
         paints nothing while the element still holds its width, so the row does not jog sideways as
         a key cycles through 'none'. An *ngIf here would remove the box and undo that. -->
    <div class="results-toolbar" data-element="results-sort-toolbar">
      <span class="sort-label">Sort by:</span>

      <span class="sort-key"
            [class.active]="this.sortKeys.type !== 'none'"
            title="Group by Adjustment Type, Alphabetically"
            data-element="sort-key-type"
            (click)="this.onSortKeyClick('type')">Type<i class="arrow"
              [ngClass]="this.sortArrowClass('type')"></i></span>

      <span class="sort-key"
            [class.active]="this.sortKeys.price !== 'none'"
            title="Order by Credit Per Day: Best to Worst"
            data-element="sort-key-price"
            (click)="this.onSortKeyClick('price')">Price<i class="arrow"
              [ngClass]="this.sortArrowClass('price')"></i></span>
    </div>

    <ets-apg-copilot-snippet-card
      *ngFor="let s of this.orderedSuggestions; let i = index"
      [suggestion]="s"
      [index]="i"
      (previewToggle)="this.previewToggle.emit($event)"
      (review)="this.review.emit($event)"
    ></ets-apg-copilot-snippet-card>

    <!-- ⚠ WHAT WAS HERE: "Top 5 max · earliest first · only tradeable results". DELETED, not
         reworded, on the owner's ruling O51 — the cap is gone and the order is his to change, so a
         line naming one is a claim the panel cannot keep. -->

  </ng-container>

</div>
